import { Tooltip } from '@nexus/lib-react/dist/core/Tooltip';
import styled from '@emotion/styled';
import { Paragraph2, Paragraph3 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { Headline6 } from '@nexus/lib-react/dist/core/Typography';
import { Info } from '@nexus/lib-react/dist/core/Icon/icons/default';
import { a2bTheme } from '../../../../../theme/styled';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import { mq } from '../../../../../commons/styles';

interface StyledProps {
  theme: a2bTheme;
}

const YouWillGetBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const YouWillGet = styled(Paragraph2)`
  flex-grow: 1;
`;
const MoneyValue = styled(Paragraph3)`
  font-weight: ${({ theme }: StyledProps) => theme.fontWeights.bold};
  &:empty {
    width: 80%;
    ${progressiveLoading()}
  }
`;

const PriceBreakBlock = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const PriceBreakLine = styled.li`
  display: flex;
  flex-wrap: nowrap;
  padding: 16px 0 15px 0;
  border-bottom: 1px solid ${({ theme }: StyledProps) => theme.colors.grey3};

  &:first-of-type {
    padding-top: 0;
  }
  &:last-child {
    border-bottom: none;
  }

  &:empty {
    &::after {
      content: '';
      width: 100%;
      height: 16px;
      margin: 3px 0;
      ${progressiveLoading()}
    }
  }
`;

const PriceBreakLabelWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

const PriceBreakLabel = styled(Paragraph2)`
  flex-grow: 1;
`;

type PriceBreakValueProps = StyledProps & { bold?: boolean };

const PriceBreakValue = styled(Paragraph2)`
  ${({ theme, bold }: PriceBreakValueProps) =>
    bold ? `font-weight: ${theme.fontWeights.bold}` : ''};

  &:empty {
    width: 50%;
    ${progressiveLoading()}
  }
`;

const InfoIcon = styled(Info)`
  cursor: pointer;
  color: ${({ theme }: StyledProps) => theme.colors.secondary};
  margin-right: 5px;
  margin-bottom: -6px;
  vertical-align: baseline !important;
`;

const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 ${({ theme }: StyledProps) => theme.space[22]};
  ${mq.smallMobile} {
    padding: 0 ${({ theme }: StyledProps) => theme.space[12]};
    p {
      font-size: ${({ theme }: StyledProps) => theme.fontSizes[12]};
    }
  }
`;

const MobileTitle = styled(Headline6)`
  text-align: center;
`;

const StyledTooltip = styled(Tooltip)`
  div {
    margin: 0px -${({ theme }: StyledProps) => theme.space[8]};
  }
`;

export default {
  YouWillGetBlock,
  YouWillGet,
  MoneyValue,
  PriceBreakBlock,
  PriceBreakLine,
  PriceBreakLabel,
  PriceBreakValue,
  PriceBreakLabelWrapper,
  InfoIcon,
  MobileTitle,
  MobileContent,
  StyledTooltip,
};
